import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { CommonService } from '../../services/common.service';
import { SessionTimerService } from 'src/app/session-expiration-alert/services/session-timer.service';

@Injectable()
export class InterceptorOneService implements HttpInterceptor {
  constructor(
    private commonService: CommonService,
    private timerService: SessionTimerService
    
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Extract required data
    const username = this.commonService.getDelegateUserInfo() ? this.commonService.getDelegateUserInfo()?.Email_Address : '';
    const authToken = sessionStorage.getItem('accessTokenForAPICalls');
    const isDelegateLoggedIn = this.commonService.getIsDelegateLoggedIn();

    // Initialize headers
    let tHeaders: HttpHeaders = req.headers;

    if (isDelegateLoggedIn && this.commonService.getDelegateTokenInfo() != null) {
      this.timerService.startTimer();
      tHeaders = tHeaders.set('Authorization', `Bearer ${authToken}`);
      tHeaders = tHeaders.set('Delegate', 'true');
      tHeaders = tHeaders.set('UserName', username);
    }
    else{
      tHeaders = tHeaders.set('Authorization', `Bearer ${authToken}`);
    }

    // Clone the request with updated headers
    const tReq = req.clone({ headers: tHeaders });

    return next.handle(tReq).pipe(
      tap(() => { }),
      catchError((error) => {
        if (error.status >= 500) {
          
        } else if (error.status === 400) {
          const errorMsg = error.error?.Message || 'Bad Request';
          if (errorMsg !== 'User not found. Invalid Domain and/or Account name.') {
            
          }
        }
        throw error;
      })
    );
  }
}
